import { createStore } from '@stencil/store';
import { RfiDoc } from 'common';

export interface RfiStoreState {
  rfis: Record<string, RfiDoc>;
}

const initialStoreState: RfiStoreState = {
  rfis: {},
};

export const { state: rfiState, onChange: rfiStoreOnChange, dispose: disposeRfiStore } = createStore<RfiStoreState>(initialStoreState);

export const upsertRfisStore = (docs: RfiDoc[]) => {
  const next = { ...rfiState.rfis };
  for (const doc of docs) {
    if (doc.deleted_date) {
      delete next[doc._id];
    } else {
      next[doc._id] = doc;
    }
  }
  rfiState.rfis = next;
};

export const getRfiByIdFromStore = (id: string): RfiDoc | undefined => {
  return rfiState.rfis[id];
};

export const resetRfiStore = () => {
  rfiState.rfis = {};
};
